import { render, staticRenderFns } from "./DialogConfirmacaoPedido.vue?vue&type=template&id=64622aa0"
import script from "./DialogConfirmacaoPedido.vue?vue&type=script&lang=js"
export * from "./DialogConfirmacaoPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports